module.exports = __webpack_public_path__ + "static/btn07-c877c0dc1426be2119d20455009e18ea.png";